import { getFetchWrapper } from "@syf-api-library/core";
import { statementsEnrollmentUrl } from "../endpoints.js";
const mutationFnFactory = (config, keyProps, headers = {}) => {
  const fetchWrapper = getFetchWrapper(config);
  return ({ enrollmentType, accountIdType }) => {
    return fetchWrapper(statementsEnrollmentUrl, {
      method: "PUT",
      body: JSON.stringify({
        "cipher.accountId": keyProps.accountId,
        accountIdType,
        enrollmentType
      }),
      headers
    });
  };
};
export {
  mutationFnFactory as default
};
//# sourceMappingURL=mutation.js.map
